import fb from '@/firebaseConfig';

/*

  STATE

 */

const state = {
  welcome: {},
  help: {},
  legal: {
    'privacy-policy': {},
    'terms-of-service': {},
  },
  marketing: {},
  isHelpLoaded: false,
};

/*

  GETTERS

 */

const getters = {
  // exampleGetter: state => { },
};

/*

  ACTIONS

 */

const actions = {
  init({ commit }) {
    fb.stringsCollection
      .where('isPreloaded', '==', true)
      .get()
      .then(querySnapshot => {
        const stringData = {};
        querySnapshot.forEach(doc => {
          const { id } = doc;
          const data = doc.data();
          const type = data.type || 'other';
          stringData[type] = stringData[type] || {};
          stringData[type][id] = data;
        });
        commit('setStrings', stringData);
      })
      .catch(error => {
        console.log('Error getting strings', error);
      });
  },

  getStringById({ commit }, id) {
    fb.stringsCollection
      .doc(id)
      .get()
      .then(doc => {
        commit('setString', doc.data());
      })
      .catch(error => {
        console.log('Error getting string', id, error);
      });
  },

  getStringByType({ commit, state }, type) {
    if (!state.isHelpLoaded) {
      fb.stringsCollection
        .where('type', '==', type)
        .get()
        .then(querySnapshot => {
          const strings = {};
          querySnapshot.forEach(doc => {
            const { id } = doc;
            const data = doc.data();
            strings[id] = data;
          });
          commit('setStringsByType', { type, strings });
        })
        .catch(error => {
          console.log('Error getting strings', error);
        });
    }
  },
};

/*

  MUTATIONS

 */

const mutations = {
  setStrings(state, stringData) {
    Object.assign(state, stringData);
  },

  setString(state, doc) {
    const type = doc.type || 'other';
    state[type] = { ...state[type], [doc.id]: doc };
  },

  setStringsByType(state, { type, strings }) {
    state[type] = strings;
    if (type === 'help') {
      state.isHelpLoaded = true;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
